import TopBar from "../../../components/LayoutComponent/TopBar/topBar";
import Tabbar from "../../../components/LayoutComponent/TabBar/Tabbar";
import "../userDashboard.css";
import BookCardsComp from "../../../components/BookComponents/BookCards";

export const UserBooksListPage = () => {

  return (
    <>
      <div className="w3-content" style={{ minHeight: "400px" }}>
        <TopBar showBackButton displayType="logo" showNotification showProfileBtn></TopBar>
        <BookCardsComp></BookCardsComp>
        <Tabbar menuType={"users"}></Tabbar>
      </div>
    </>
  );
};

export default UserBooksListPage;
